import { EditorModule } from '@tinymce/tinymce-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentBuilderComponent } from './document-builder.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicModule } from 'ng-dynamic-component';
import {
  DocumentBuilderDocumentDirective,
  DocumentBuilderPanelTopDirective,
  DocumentBuilderPanelBottomDirective,
} from './document-builder-sections';
import { MatIconModule } from '@angular/material/icon';
import { ButtonModule, ButtonToggleModule } from '@lockton-apps/shared/ui/lui';
import { DocumentBuilderContentComponent } from './document-builder-content.component';
import { DocumentBuilderPageComponent } from './document-builder-page.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { OrderByPipe } from '@lockton-apps/shared/util/ng-lodash';

const publicApi = [
  DocumentBuilderComponent,
  DocumentBuilderPageComponent,
  DocumentBuilderDocumentDirective,
  DocumentBuilderContentComponent,
  DocumentBuilderPanelTopDirective,
  DocumentBuilderPanelBottomDirective,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    MatIconModule,
    DynamicModule,
    EditorModule,
    DynamicModule,
    MatTooltipModule,
    MatButtonToggleModule,
    ButtonToggleModule,
    OrderByPipe,
  ],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class DocumentBuilderModule {}
